import { EncryptionEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
const bulkListPath = '/organizations/:organizationId/encryptions/list';
export const OrganizationEncryptionResource = authResource({
    path: '/organizations/:organizationId/encryptions',
    schema: EncryptionEntity
}).extend((BaseResource) => ({
    bulkRevoke: BaseResource.update.extend({
        path: '/organizations/:organizationId/encryptions/revoke',
        method: 'POST',
        body: {
            encryptionGUIDs: []
        },
        schema: undefined
    }),
    bulkShred: BaseResource.update.extend({
        path: '/organizations/:organizationId/encryptions/shred',
        method: 'POST',
        body: {
            encryptionGUIDs: []
        },
        schema: undefined
    }),
    getBulkList: BaseResource.getList.extend({
        path: bulkListPath,
        method: 'POST',
        body: {
            encryptionGUIDs: [],
            fetch: 0,
            offset: 0,
            sortBy: ''
        },
        searchParams: {},
        schema: paginatedSchema(EncryptionEntity),
        sideEffect: false
    })
}));
